import { buildClientImgixUrl } from '@air/component-imgix-image';

import { getPageUrl } from '~/utils/Url';

const MAX_OG_RATIO = 1.91;
const MIN_OG_RATIO = 1 / MAX_OG_RATIO;

const toAbsoluteUrl = (url: string, origin: string): string => (url.startsWith('/') ? `${origin}${url}` : url);

export const getClipOgImageUrl = (
  image: string | null | undefined,
  width: number,
  height: number,
  origin = getPageUrl(),
): string | undefined => {
  if (!image) {
    return undefined;
  }

  if (!width || !height) {
    return toAbsoluteUrl(buildClientImgixUrl(image, { w: 1200, h: 1200, fit: 'clip', auto: 'format' }), origin);
  }

  const ratio = width / height;

  if (ratio > MAX_OG_RATIO) {
    return toAbsoluteUrl(buildClientImgixUrl(image, { w: 1200, h: 628, fit: 'crop', auto: 'format' }), origin);
  }

  if (ratio < MIN_OG_RATIO) {
    return toAbsoluteUrl(buildClientImgixUrl(image, { w: 628, h: 1200, fit: 'crop', auto: 'format' }), origin);
  }

  return toAbsoluteUrl(buildClientImgixUrl(image, { w: 1200, h: 1200, fit: 'clip', auto: 'format' }), origin);
};
